/*
 * @Author: Ryan
 * @Date: 2026-01-27
 * @Description: UGC Video Types Section - 展示三种 UGC 视频类型
 */
import Image from 'next/image';
import React from 'react';

import styles from './index.module.scss';

const TOOLS_DATA = [
  {
    id: 'image-to-video',
    imageUrl: 'https://assets.falcocut.ai/ai-ugc-video-generator/image-to-video.webp',
    title: 'Image to Video',
    description:
      'Turn any product photo into an eye-catching video in just a few minutes. Ideal for make quick promos or authentic testimonials for your online store or brand.',
  },
  {
    id: 'text-to-video',
    imageUrl: 'https://assets.falcocut.ai/ai-ugc-video-generator/text-to-video.webp',
    title: 'Text to Video',
    description:
      'Start with a simple script and watch the AI generate a polished video ad with natural movements and expressive delivery that feels genuinely creator-made.',
  },
  {
    id: 'ai-avatars',
    imageUrl: 'https://assets.falcocut.ai/ai-ugc-video-generator/scripted-ugc-video.webp',
    title: 'AI Avatars',
    description:
      'Pick a realistic actor from our extensive avatar library or create your own branded avatar to talk to your customers and build real trust.',
  },
];

const UGCVideoTypes: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* 标题区域 */}
        <div className={styles.header}>
          <h2 className={styles.title}>What Kind of UGC Videos Can FalcoCut Make</h2>
          <p className={styles.subtitle}>
            FalcoCut makes it easy to turn your simple ideas or product photos into
            high-quality video ads. Use our powerful AI tools and lifelike actors to
            create UGC-style creatives that looks professional without any complex
            editing.
          </p>
        </div>

        {/* 工具卡片区域 */}
        <div className={styles.toolsWrapper}>
          {TOOLS_DATA.map((tool) => (
            <div key={tool.id} className={styles.toolCard}>
              <div className={styles.imageWrapper}>
                <Image
                  src={tool.imageUrl}
                  alt={tool.title}
                  width={440}
                  height={400}
                  className={styles.image}
                />
              </div>
              <div className={styles.toolContent}>
                <h3 className={styles.toolTitle}>{tool.title}</h3>
                <p className={styles.toolDescription}>{tool.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UGCVideoTypes;
